import { css } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
} from '../styles/variables.style';
import iconone from '../assets/images/img-3928.jpeg';
import icontwo from '../assets/images/img-3827.jpeg';
import icononedetail from '../assets/images/event-icon-1.png';
import icontwodetail from '../assets/images/event-icon-2.png';
import levelbg from '../assets/images/level-tag.png';

export const batchBanner = css`
  display: block;
  width: 100%;
  position: relative;
  padding: 0px 40px;
  @media (max-width: 767px) {
    padding: 0 20px;
    margin-bottom:0;
  }
  img {
    width: 100%;
    border-radius: 10px;
    
  }
  span {
    width: 100%;
    max-width: 280px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media (max-width: 767px) {
      text-align: center;
    }
    img {
      width: 100%;
      max-width: 280px;
      @media (max-width: 767px) {
        max-width: 150px;
      }
    }
  }
`;

export const batchTitle = css`
  text-align: center;
  padding: 20px 0;
  font-size: 36px;
  font-weight: 500;
  position: relative;
  font-family: Fredoka one, sans-serif;
  @media (max-width: 767px) {
    padding: 30px 0;
    font-size: 28px;
  }
  &:after {
    content: '';
    width: 65px;
    height: 4px;
    background: #edc224;
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translate(-50%);
    @media (max-width: 767px) {
      bottom: 18px;
    }
  }
`;

export const cardEventsFluid = css`
  width: 100%;
  max-width: 1280px;
  margin: auto;
  padding: 0 15px;
  position: relative;
  &:before {
    @media (min-width: ${breakpoints.lg.up}) {
      content: '';
      width: 100%;
      background: url(${iconone}) no-repeat 18% -22px,
        url(${icontwo}) no-repeat 83% 65%;
      padding: 50px 20px;
      position: absolute;
      top: -120px;
      height: 160px;
      z-index: -1;
    }
  }
  .col-md-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    padding: 10px 30px;
    @media (max-width: 992px) {
      padding: 10px 10px;
      @media (max-width: 767px) {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        padding: 0 20px;
        margin-bottom: 20px;
      }
    }
    &:nth-child(01) {
        .col{
            .card{
                background:#6bd5ff;
                border-color:#00c4ff;
                .overflow{
                    a{
                        display: inline-block;
                        width: 100%;
                        img.card-img-top{
                            object-fit: cover;
                            height: 240px;
                        }
                    }
                }
            }
        }
      .card-body {          
        h4 {
          color: ${appColors.white} !important;
          text-transform:uppercase;
          font-weight: 400 !important;
          &:last-child{
              color:#000 !important;
              text-transform:inherit;
          }
        }
      }
    }
    &:nth-child(02) {
        .col{
            .card{
                background:#f16602;
                border-color:#de7028;
                .overflow{
                    a{
                        display: inline-block;
                        width: 100%;
                        img.card-img-top{
                            object-fit: cover;
                            height: 240px;
                        }
                    }
                }
            }
        }
      .card-body {          
        h4 {
          color: ${appColors.white} !important;
          text-transform:uppercase;
          font-weight: 400 !important;
          &:last-child{
              color:#000 !important;
              text-transform:inherit;
          }
        }
      }
    }
    &:nth-child(03) {
        .col{
            .card{
                background:#edc224;
                border-color:#edc224;
                .overflow{
                    a{
                        display: inline-block;
                        width: 100%;
                        img.card-img-top{
                            object-fit: cover;
                            height: 240px;
                        }
                    }
                }
            }
        }
      .card-body {          
        h4 {
          color: ${appColors.white} !important;
          text-transform:uppercase;
          font-weight: 400 !important;
          &:last-child{
              color:#000 !important;
              text-transform:inherit;
          }
        }
      }
    }
    &:nth-child(04) {
        .col{
            .card{
                background:#72ff6b;
                border-color:#72ff6b;
                .overflow{
                    a{
                        display: inline-block;
                        width: 100%;
                        img.card-img-top{
                            object-fit: cover;
                            height: 240px;
                        }
                    }
                }
            }
        }
      .card-body {          
        h4 {
          color: ${appColors.white} !important;
          text-transform:uppercase;
          font-weight: 400 !important;
          &:last-child{
              color:#000 !important;
              text-transform:inherit;
          }
        }
      }
    }
    &:nth-child(05) {
        .col{
            .card{
                background:#2b3cdd;
                border-color:#2b3cdd;
                .overflow{
                    a{
                        display: inline-block;
                        width: 100%;
                        img.card-img-top{
                            object-fit: cover;
                            height: 240px;
                        }
                    }
                }
            }
        }
      .card-body {          
        h4 {
          color: ${appColors.white} !important;
          text-transform:uppercase;
          font-weight: 400 !important;
          &:last-child{
              color:#000 !important;
              text-transform:inherit;
          }
        }
      }
    }


  }
  .card {
    width: 100%;
    box-shadow: none;
    border: 2px solid #de7028;
    border-radius: 8px;
    transition: all 0.5s;
    padding: 15px;
    height: auto;
    min-height: 420px;
    @media (max-width: 992px) {
      margin-bottom: 0;
    }
    &:hover {
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.28) !important;
      transition: all 0.5s;
    }
    .overflow {
      img {
        width: 100%;
        border-radius: 8px;
        object-fit: cover;
        &:hover {
          transform: scale(1);
        }
      }
      .card-body {
        width: 100%;
        max-width: 190px;
        margin: auto;
        h4 {
          padding: 0;
          margin: 10px 0;
          text-align: center;
          color: #dd6e2b;
          font-size: 18px;
          font-family: Fredoka one, sans-serif;
          font-weight: 400;
        }
        .editevenbutton {
          padding: 13px 0;
          background: #dd6e2b;
          border-radius: 8px;
          text-transform: uppercase;
          &:hover {
            background: #edc224;
            transition: all 0.5s;
          }
        }
      }
    }
  }
`;

export const cardEventsDetailsFluid = css`
  width: 100%;
  max-width: 1280px;
  margin: auto;
  padding: 0 15px;
  position: relative;
  &:before {
    @media (min-width: ${breakpoints.lg.up}) {
      content: '';
      width: 100%;
      background: url(${icononedetail}) no-repeat 18% 0px,
        url(${icontwodetail}) no-repeat 83% 65%;
      padding: 50px 20px;
      position: absolute;
      top: -120px;
      height: 160px;
      z-index: -1;
    }
  }
  .col-md-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    padding: 10px 30px;
    @media (max-width: 992px) {
      padding: 10px 10px;
      @media (max-width: 767px) {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        padding: 0 20px;
        margin-bottom: 20px;
      }
    }
    
    .col{
        .card{
            background:#6bd5ff;
            border-color:#00c4ff;
            .overflow{
                a{
                    display: inline-block;
                    width: 100%;
                    img.card-img-top{
                    object-fit: cover;
                    height: 240px;
                }
              }
          }
        }
    }
    .card-body {
        max-width:100% !important;    
        h4 {
            color: ${appColors.white} !important;
            text-transform:uppercase;
            font-weight: 400 !important;
            &:nth-child(02){
                color:#000 !important;
            }
            &:nth-child(03){
                color:#000 !important;
            }
            &:last-child{
                color:#000 !important;
                text-transform:inherit;
            }
        }
    }

  }
  .lavelColsMain{
    background: url(${levelbg}) no-repeat;
    padding:34px 27px;
    display: inline-block;
    margin: 0 !important;
    position: absolute;
    right: -20px;
    top: -24px;
    z-index: 99;
    text-align:center;
    color:#000;
    font-family: Fredoka one,sans-serif;
    font-weight: 300;
    @media(max-width:767px){
      right: -15px;
      top: -20px;
    }
    span{
      display:block;
    }
  }
  .card {
    width: 100%;
    box-shadow: none;
    border: 2px solid #de7028;
    border-radius: 8px;
    transition: all 0.5s;
    padding: 15px;
    height: auto;
    min-height: 420px;
    position:relative;
    @media (max-width: 992px) {
      margin-bottom: 0;
    }
    &:hover {
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.28) !important;
      transition: all 0.5s;
    }
    .overflow {
      img {
        width: 100%;
        border-radius: 8px;
        object-fit: cover;
        &:hover {
          transform: scale(1);
        }
      }
      .card-body {
        width: 100%;
        max-width: 190px;
        margin: auto;
        h4 {
          padding: 0;
          margin: 10px 0;
          text-align: center;
          color: #dd6e2b;
          font-size: 18px;
          font-family: Fredoka one, sans-serif;
          font-weight: 400;
        }
        h6{
          margin:10px 0;
        }
        .eventsBtn{
          a{
            display: inline-block;
            background: #fff;
            width: 100%;
            max-width: 150px;
            text-transform: uppercase;
            padding: 10px 0;
            font-size: 15px;
            border-radius: 8px;
            color: #6bd5ff;
            transition: all 0.5s;
            &:hover{
              background: #ffca00;
              color: #000;
              transition: all 0.5s;
            }
          }
        }
        .editevenbutton {
          padding: 13px 0;
          background: #dd6e2b;
          border-radius: 8px;
          text-transform: uppercase;
          &:hover {
            background: #edc224;
            transition: all 0.5s;
          }
        }
      }
    }
  }
`;
export const subTitle = css`
  text-align: center;
  margin: 10px auto;
  font-size: 30px;
  font-family: ${fontFamily.fredoka};
`;